import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.jsx';
import './estilo/tokens.css';
import './estilo/base.css';
import './estilo/app.css';

/**
 * A partida.
 *
 * A ordem dos três CSS importa e não é alfabética: `tokens` define as
 * variáveis, `base` veste os elementos com elas, `app` posiciona as telas.
 * Trocar a ordem faz o tema escuro parar de valer em algum lugar difícil de
 * achar depois.
 */
createRoot(document.getElementById('raiz')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
